// extracted by mini-css-extract-plugin
export default {"grid":"KeyMetricsGlossary_grid__Ievn4","cell":"KeyMetricsGlossary_cell__eoi8K","term":"KeyMetricsGlossary_term__ezZyr","text":"KeyMetricsGlossary_text__212bP"};